import { t } from 'i18next';
import React, { useDeferredValue, useEffect, useMemo, useState } from 'react';
import { Trans } from 'react-i18next';
import { toMplatDate, translit1 } from '../../../components/common';
import Button from '../../../components/mplat/Button/Button';
import MultiSelect from '../../../components/mplat/MultiSelect';
import { Searcher } from '../../../components/mplat/Searcher';
import { useAuth, useLanguage } from '../../../hooks';
import { Promo, useLazyGetAllPromoQuery, useLazyGetPublicPromosQuery } from '../../../services/content_v1';


export const PROMO_CATEGORIES: Record<string, string> = {
    fil: 'Films',
    ser: 'Series2',
    pro: 'content:SERVICES',
    rec: 'Ad',
}

interface PromoItemProps {
    item: Promo,
}

export function PromoItem({ item }: PromoItemProps) {
    const lang = useLanguage();

    return (
        <article
            className="welcome-sale__item"
            data-heading="Акция доступна для&nbsp;заререгистрированных пользователей"
            onClick={() => location.pathname = `/${lang}/public-promo/${item.id}_${translit1(item.title) || '_'}/`}
        >
            <h3 className="welcome-sale__item-heading">
                {item.title}
            </h3>
            <p className="welcome-sale__item-copy">
                {item.summary}
            </p>
            <ul className="welcome-sale__item-tags">
                <li><Trans>until</Trans>&nbsp;{toMplatDate(item.finish_at, true)}</li>
                {item.tags.map((tg) => <li key={tg}><Trans>{PROMO_CATEGORIES[tg]}</Trans></li>)}
            </ul>
            <p className="welcome-sale__item-cta">
                <Button><Trans>Take part</Trans></Button>
            </p>
        </article>
    )
}


const Promos: React.FC = () => {
    const { user } = useAuth();
    const lang = useLanguage();

    const [fetchPromos, { data: dataPromos }] = useLazyGetAllPromoQuery();
    const [fetchPublicPromos, { data: dataPublicPromos }] = useLazyGetPublicPromosQuery();

    const [promos, setPromos] = useState<Promo[]>([]);
    const [search, setSearch] = useState('');
    const [category, setCategory] = useState<string[]>([]);
    // const [initiator, setInitiator] = useState<string[]>([]);
    const deferredSearch = useDeferredValue(search);

    const availCategories = useMemo(() => [
        ...Object.entries(PROMO_CATEGORIES).map(([k, v]) => ({ value: k, label: t(v) }))
    ], [lang, t]);

    // const availInitiators = useMemo(() => [
    //     { value: 'msk', label: 'MSK-IX' },
    //     { value: 'med', label: 'Медиабаза' },
    //     { value: 'via', label: 'Viasat' },
    //     { value: 'rtv', label: 'RTVI' },
    // ], []);

    useEffect(() => {
        if (user) {
            fetchPromos({
                offset: 0,
                limit: -1,
                tag: category.join(','),
                search: deferredSearch
            });
        } else {
            fetchPublicPromos({
                offset: 0,
                limit: -1,
                tag: category.join(','),
                search: deferredSearch
            });
        }
    }, [user, category, deferredSearch, lang]);

    useEffect(() => {
        setPromos(dataPublicPromos?.results.data || []);
    }, [dataPublicPromos]);

    useEffect(() => {
        setPromos(dataPromos?.results.data || []);
    }, [dataPromos]);

    return (
        <>
            <header className="main__header">
                <h1 className="main__header-heading"><Trans>cms:PROMO</Trans></h1>
            </header>

            <div className="main__content-filter" data-target=".welcome-sale__grid">
                <div className="main__controls">
                    <div className="main__controls-filter">
                        <Searcher value={search} onChange={(v) => setSearch(v)} />
                        <div className="main__controls-filter-item">
                            <MultiSelect minimized placeholder={t('Category')} value={category} options={availCategories} setValue={(v) => setCategory(v)} />
                        </div>
                        {/* <div className="main__controls-filter-item">
                            <MultiSelect minimized placeholder={t('Initaitor')} value={initiator} options={availInitiators} setValue={(v) => setInitiator(v)} />
                        </div> */}
                    </div>
                </div>
            </div>

            <div className="welcome-sale__grid">
                {promos.map((prom) => <div key={prom.id} className="welcome-sale__grid-item"><PromoItem item={prom} /></div>)}
            </div>
        </>
    );
};

export default Promos;